module.exports = __webpack_public_path__ + "img/form-soc.6be8b48c.svg";